import Vue from "vue";
import moment from "moment";

Vue.prototype.$time = moment;

export default moment;
